import {message} from "antd";
import {MissingFindingSummaryError} from "../domain/SbomProjectVersion";

export function handleFindingSummaryError(error: unknown): never {
    if (error instanceof MissingFindingSummaryError) {
        message.error("Could not load finding statistics. Please reload the page.", 5);
    }

    throw error;
}
